import { InjectionToken } from '@angular/core';

export class IconType {
  static readonly Edit = 'edit';
  static readonly Arrow = 'arrow';
  static readonly Close = 'close';
  static readonly Document = 'document';
  static readonly Minus = 'minus';
  static readonly Plus = 'plus';
  static readonly Trash = 'trash';
  static readonly Alert = 'alert';
  static readonly Info = 'info';
  static readonly Success = 'success';
  static readonly Warning = 'warning';
  static readonly Discount = 'discount';
  static readonly UI = [
    'edit',
    'arrow',
    'close',
    'document',
    'minus',
    'plus',
    'trash',
    'alert',
    'info',
    'success',
    'warning',
  ];
}

export class IconSizes {
  static readonly MD = 'md';
  static readonly LG = 'lg';
  static readonly XLG = 'xlg';
  static readonly ALL = [IconSizes.MD, IconSizes.LG, IconSizes.XLG];
}

export class IconSpacing {
  static readonly LEFT = 'space-left';
  static readonly RIGHT = 'space-right';
  static readonly RIGHTLARGE = 'space-right-lg';
  static readonly SIDES = 'space-sides';
  static readonly ALL = [
    IconSpacing.LEFT,
    IconSpacing.RIGHT,
    IconSpacing.RIGHTLARGE,
    IconSpacing.SIDES,
  ];
}

export interface SvgIconType {
  name: string;
  data: string;
}

export interface SvgIconConfig {
  icons?: SvgIconType | SvgIconType[];
}

export const SVG_ICONS_CONFIG = new InjectionToken<SvgIconConfig>(
  'SVG_ICONS_CONFIG'
);
export const SVG_ICONS = new InjectionToken<SvgIconConfig['icons']>(
  'SVG_ICONS'
);
